<template>
  <Panel title="Chromatic Mediants">
    <p class="max-w-lg mx-auto mt-4 text-sm font-light leading-tight text-gray-600">
      In music, chromatic mediants are "altered mediant (iii) and submediant (vi) chords."
    </p>

    <div class="overflow-y-auto custom-scroll">
      <table class="mx-auto mt-4 mb-2 font-serif table-auto">
        <thead>
          <tr>
            <th class="px-4 py-2 text-xs font-bold uppercase whitespace-no-wrap">Tonic Triad</th>
            <th class="px-4 py-2 text-xs font-bold uppercase whitespace-no-wrap">Diatonic Mediants</th>
            <th colspan="3" class="px-4 py-2 text-xs font-bold uppercase whitespace-no-wrap">Chromatic Mediants</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="scaleType === 'major'">
            <td class="px-4 py-2 font-bold whitespace-no-wrap border">{{ chromaticScale.notes()[0].chord().name.replace("b", "&flat;").replace("#", "&sharp;") }} Major</td>

            <td class="px-4 py-2 font-bold whitespace-no-wrap border border-l-4">
              <span class="text-gray-500">(iii)</span> {{ chromaticScale.notes()[4].chord("m").name.replace("b", "&flat;").replace("#", "&sharp;").replace("m", minorSymbol) }}
            </td>

            <td class="px-4 py-2 font-bold whitespace-no-wrap border border-l-4">
              <span class="text-gray-500">(III)</span> {{ chromaticScale.notes()[4].chord().name.replace("b", "&flat;").replace("#", "&sharp;") }}
            </td>
            <td class="px-4 py-2 font-bold whitespace-no-wrap border">
              <span class="text-gray-500">(&flat;III)</span> {{ chromaticScale.notes()[3].chord().name.replace("b", "&flat;").replace("#", "&sharp;") }}
            </td>
            <td class="px-4 py-2 font-bold whitespace-no-wrap border">
              <span class="text-gray-500">(&flat;iii)</span> {{ chromaticScale.notes()[3].chord("m").name.replace("b", "&flat;").replace("#", "&sharp;").replace("m", minorSymbol) }}
            </td>
          </tr>

          <tr v-else>
            <td class="px-4 py-2 font-bold whitespace-no-wrap border">{{ chromaticScale.notes()[0].chord().name.replace("b", "&flat;").replace("#", "&sharp;") }} minor</td>

            <td class="px-4 py-2 font-bold whitespace-no-wrap border border-l-4">
              <span class="text-gray-500">(III)</span> {{ chromaticScale.notes()[3].chord(scaleType === 'major' ? "m" : "").name.replace("b", "&flat;").replace("#", "&sharp;").replace("m", minorSymbol) }}
            </td>

            <td class="px-4 py-2 font-bold whitespace-no-wrap border border-l-4">
              <span class="text-gray-500">(iii)</span> {{ chromaticScale.notes()[3].chord("m").name.replace("b", "&flat;").replace("#", "&sharp;").replace("m", minorSymbol) }}
            </td>
            <td class="px-4 py-2 font-bold whitespace-no-wrap border">
              <span class="text-gray-500">(&sharp;III)</span> {{ chromaticScale.notes()[4].chord().name.replace("b", "&flat;").replace("#", "&sharp;") }}
            </td>
            <td class="px-4 py-2 font-bold whitespace-no-wrap border">
              <span class="text-gray-500">(&sharp;iii)</span> {{ chromaticScale.notes()[4].chord("m").name.replace("b", "&flat;").replace("#", "&sharp;").replace("m", minorSymbol) }}
            </td>
          </tr>

          <tr v-if="scaleType === 'major'">
            <td class="px-4 py-2 font-bold whitespace-no-wrap border">&nbsp;</td>

            <td class="px-4 py-2 font-bold whitespace-no-wrap border border-l-4">
              <span class="text-gray-500">(vi)</span> {{ chromaticScale.notes()[9].chord("m").name.replace("b", "&flat;").replace("#", "&sharp;").replace("m", minorSymbol) }}
            </td>

            <td class="px-4 py-2 font-bold whitespace-no-wrap border border-l-4">
              <span class="text-gray-500">(VI)</span> {{ chromaticScale.notes()[9].chord().name.replace("b", "&flat;").replace("#", "&sharp;") }}
            </td>
            <td class="px-4 py-2 font-bold whitespace-no-wrap border">
              <span class="text-gray-500">(&flat;VI)</span> {{ chromaticScale.notes()[8].chord().name.replace("b", "&flat;").replace("#", "&sharp;") }}
            </td>
            <td class="px-4 py-2 font-bold whitespace-no-wrap border">
              <span class="text-gray-500">(&flat;vi)</span> {{ chromaticScale.notes()[8].chord("m").name.replace("b", "&flat;").replace("#", "&sharp;").replace("m", minorSymbol) }}
            </td>
          </tr>
          <tr v-else>
            <td class="px-4 py-2 font-bold whitespace-no-wrap border">&nbsp;</td>

            <td class="px-4 py-2 font-bold whitespace-no-wrap border border-l-4">
              <span class="text-gray-500">(VI)</span> {{ chromaticScale.notes()[8].chord().name.replace("b", "&flat;").replace("#", "&sharp;") }}
            </td>

            <td class="px-4 py-2 font-bold whitespace-no-wrap border border-l-4">
              <span class="text-gray-500">(vi)</span> {{ chromaticScale.notes()[8].chord("m").name.replace("b", "&flat;").replace("#", "&sharp;").replace("m", minorSymbol) }}
            </td>
            <td class="px-4 py-2 font-bold whitespace-no-wrap border">
              <span class="text-gray-500">(&sharp;VI)</span> {{ chromaticScale.notes()[9].chord().name.replace("b", "&flat;").replace("#", "&sharp;") }}
            </td>
            <td class="px-4 py-2 font-bold whitespace-no-wrap border">
              <span class="text-gray-500">(&sharp;vi)</span> {{ chromaticScale.notes()[9].chord("m").name.replace("b", "&flat;").replace("#", "&sharp;").replace("m", minorSymbol) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </Panel>
</template>

<script>
import Panel from "./Panel.vue";
import teoria from "teoria";
const note = teoria.note;
const scale = teoria.scale;

export default {
  props: {
    rootNote: String,
    minorSymbol: String,
    scaleType: String
  },
  components: { Panel },
  computed: {
    chromaticScale() {
      return scale(note(this.rootNote), "chromatic");
    },
    majorScale() {
      return scale(note(this.rootNote), "major");
    },
    minorScale() {
      return scale(note(this.rootNote), "minor");
    }
  }
};
</script>
